import { fin } from "@openfin/core";
export const DEFAULT_WIDTH = 130;
export const DEFAULT_HEIGHT = 30;
export const MAX_HEIGHT = 150;
export const NAMESPACE = 'alk-autocomplete';
export function getCurrentWindow() {
  if (Boolean(window['fin'])) {
    return fin.me;
  }
  else {
    return window;
  }
}
//# sourceMappingURL=overlay-openfin.utils.js.map
